import React from 'react';
import { useSelector } from 'react-redux';
import { remittanceDetailInfo } from './constants';
import { LinkedClaims } from './linkedClaims';

export const ClaimPaymentDetails = () => {
    const remittanceById = useSelector((state) => state.claimPayment.remittanceById);

    function getDetailDisplay(detail) {
        if (detail && detail !== 'Undefined Undefined') {
            return detail;
        } else {
            return '--';
        }
    }

    return (
        <>
            <div className="details-wrapper">
                {!!remittanceDetailInfo(remittanceById).length && (
                    <ol className="details-list-box">
                        {remittanceDetailInfo(remittanceById).map(
                            (item, index) =>
                                item?.detail && (
                                    <li key={index} style={{ background: item?.background ? item?.background : '#F4F5F7' }}>
                                        <p className="detail-title-style"> {item.detailText}</p>
                                        <p className="detail-value-style">{getDetailDisplay(item.detail)}</p>
                                    </li>
                                )
                        )}
                    </ol>
                )}
            </div>

            <div>
                <LinkedClaims />
            </div>
        </>
    );
};
